import { Component } from "@angular/core";

@Component({
	selector: "app-sso-maintenance",
	templateUrl: "./sso-maintenance.component.html",
	styleUrls: ["./sso-maintenance.component.css"],
})
export class SSOMaintenanceComponent {}
